import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const irThemeLight = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#d42a1d',
      },
      secondary: {
        main: '#1f2124',
      },
      error: {
        main: '#E62D1E',
      },
      warning: {
        main: '#f29f05',
      },
      info: {
        main: '#0c4e99',
      },
      success: {
        main: '#528a04',
      },
      background: {
        default: '#D7DEE8',
        paper: '#fafafa',
      },
      banner: {
        info: '#0c4e99',
        error: '#E62D1E',
        text: '#343b58',
        link: '#565a6e',
      },
      errorBackground: '#8c4351',
      warningBackground: '#8f5e15',
      infoBackground: '#343b58',
      navigation: {
        background: '#1F2124',
        indicator: '#D42A1D',
        color: '#ffffff',
        selectedColor: '#ffffff',
      },
    },
  }),
  fontFamily: 'Roboto,sans-serif',
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: ['#d42a1d', '#1F2124'], shape: shapes.wave }),
  },
  // components: {
  //   // StyleOverride für MembersListCard
  //   [EntityUserProfileCard as any]: {
  //     styleOverrides: {
  //       Box: {
  //         backgroundColor: '#ff0000',
  //         color: '#ff0000',
  //         borderRadius: '12px',
  //         boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  //       },
  //     },
  //   },
  // },
});
